var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16034_11347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04883 4.50537V57.2311H56.7745V4.50537H4.04883ZM55.3696 55.8262H5.45374V5.91029H55.3696V55.8262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6016 42.5219H14.2957C14.6263 42.5219 14.9155 42.5632 15.2461 42.6871C15.5767 42.8111 15.8659 42.9351 16.1139 43.183C16.3618 43.3896 16.5684 43.6788 16.7337 43.9681C16.899 44.2987 16.9816 44.6705 16.9816 45.0838C16.9816 45.497 16.899 45.8689 16.7337 46.1994C16.5684 46.53 16.3618 46.7779 16.1139 46.9845C15.8659 47.1911 15.5767 47.3564 15.2461 47.4804C14.9155 47.6043 14.6263 47.6457 14.2957 47.6457H12.6016V42.5219ZM13.1387 47.1911H14.1718C14.5437 47.1911 14.8742 47.1498 15.1635 47.0258C15.4527 46.9019 15.7006 46.7366 15.8659 46.5713C16.0725 46.3647 16.1965 46.1581 16.2791 45.9102C16.3618 45.6623 16.4031 45.4143 16.4031 45.1251C16.4031 44.8772 16.3618 44.5879 16.2791 44.34C16.1965 44.0921 16.0312 43.8854 15.8659 43.6788C15.6593 43.4722 15.4527 43.3069 15.1635 43.2243C14.8742 43.1003 14.5437 43.059 14.1718 43.059H13.1387V47.1911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2462 47.1911H22.9733V47.6457H19.709V42.5219H22.8907V42.9764H20.2462V44.7119H22.7254V45.1664H20.2462V47.1911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2945 46.9037V42.5649H29.8316V47.6888H29.1705L26.1954 43.3087V47.6888H25.6582V42.5649H26.3193L29.2945 46.9037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4599 47.6457H33.9227V42.9764H32.2285V42.5219H36.154V42.9764H34.4599V47.6457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5528 47.6457H38.0156L40.2056 42.5219H40.7015L42.8915 47.6457H42.313L41.7345 46.3234H39.09L38.5528 47.6457ZM39.3379 45.8275H41.5692L40.4536 43.1003L39.3379 45.8275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.824 47.1911H48.2206V47.6457H45.3281V42.5219H45.8653V47.1911H45.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3457 35.3325V36.4895H42.0637V38.5556H52.4766V35.3325H8.3457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5586 14.0944V21.2016H34.2531V14.0944H29.4598L24.6666 26.5733L19.9146 14.0944H15.0801V31.9037H18.0965V17.1108H18.1792L23.5509 31.9037H25.7822L31.0713 17.3587V31.9037H31.2366H34.2531V24.0527H42.5586V31.9037H45.7403V14.0944H42.5586Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16034_11347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.8246,
    height: 61.7337,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.5d0bb333517c3dc8081cf59f4a67dbba.svg";
export { ForwardRef as ReactComponent };